<template>
  <v-app>
    <!-- Header -->
    <app-header v-if="$route.name !== 'Login' && $route.name !== 'Loginform'  && $route.name !== 'Call' && $route.name !== 'Password'">
    </app-header>

    <!-- main content -->
    <v-main>
      <v-fade-transition>
        <router-view :name="routeName"></router-view>
      </v-fade-transition>
    </v-main>
  </v-app>
</template>

<script>
export default {
  name: "App",

  data: () => ({
    screenIdle: false,
    mode: process.env.VUE_APP_NODE_ENV,
    url: process.env.VUE_APP_URL
  }),
  
  onIdle() {
    this.screenIdle = true
    this.signOut()
  },
  onActive() {
    this.screenIdle = false
  },

  watch: {
    screenIdle(val) {
      if (val) {
        console.log('[screen-idle]')
      }
    }
  },

  components: {
    AppHeader: () => import("@/components/app/header/AppHeader.vue"),
  },

  computed: {
    routeName() {
      const user_type = this.$store.getters["profile/type"];
      const view_for = this.$route.meta.view_for;

      if (this.$route.meta.force_default || !Array.isArray(view_for))
        return "default";
      else return user_type;
    }
  },

  mounted() {
    console.log(`[Thursday, March 11, 2021 2PM - ${this.mode} (${this.url})]`);
  },

  methods: {
    async signOut() {
      this.$store.dispatch('profile/signOut');
    }
  }
};
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=Poppins:wght@400;500&display=swap");

#app {
  font-family: "Poppins", sans-serif !important;
  overflow: hidden !important;
}

.clickable {
  cursor: pointer;
}

.clickable:hover {
  color: #258bf5;
}

#profileContainer {
  height: 100%;
}

/* adds automatic overflow for y axis */
.overflow-y {
  overflow-y: hidden;
}
.overflow-y:hover,
.overflow-y:focus {
  overflow-y: overlay;
}
/* for phone users */
@media only screen and (max-width: 600px) {
  .overflow-y {
    overflow-y: auto;
  }
}

/* overflow:overlay doesn't work on firefox */
@-moz-document url-prefix() {
  .overflow-y {
    overflow-y: auto;
    scrollbar-width: thin;
    scrollbar-color: #258bf5 rgba(235, 235, 235, 0.9);
  }
}

.primary-label .v-label {
  color: #258bf5 !important;
  opacity: 1;
}

.secondary-label .v-label {
  color: #f0f0f0 !important;
  opacity: 1;
}

/*Customized scrollbar*/

/* width */
::-webkit-scrollbar {
  height: 7px;
  width: 5px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #ebebeb;
  /* width: 10px; */
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #b9d0e7;
  border-radius: 20px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #258bf5;
}
/* :hover::-webkit-scrollbar {
    width: 6px;
  } */

/* Text */
.error-text {
  font-size: 12px;
  color: #ff5252;
}

.pre-wrap {
  white-space: pre-wrap;
}

.line-clamp-5 {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 5;
  -webkit-box-orient: vertical;
}

.line-clamp-4 {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
}

button.grey.darken-2 {
  height: 33px !important;
  min-width: 180px !important;
  padding: 0 12.4444444444px;
  margin-right: 30px;
  margin-top: -10px;
  margin-bottom: 10px;
}

</style>
